import { CloseOutlined, CollectionsOutlined } from "@mui/icons-material";
import {
  Box,
  Typography,
  Drawer,
  ImageList,
  ImageListItem,
} from "@mui/material";
import {
  NextSliderArrow,
  PrevSliderArrow,
} from "features/searchStore/components/SliderArrow";
import { useRef, useState } from "react";
import Slider from "react-slick";

const itemData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export function PhotoDrawerBtn() {
  const slideRef = useRef<Slider | null>(null);
  const [openPhotograph, setOpenPhotograph] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(1);

  const handleSelectImage = (index: number) => {
    slideRef.current?.slickGoTo(index - 1);
  };

  return (
    <>
      <Box
        display="flex"
        flex={1}
        alignItems="center"
        justifyContent="center"
        borderColor="divider"
        p={2}
        sx={{
          cursor: "pointer",
          "&:hover": {
            opacity: "0.6",
          },
        }}
        onClick={() => setOpenPhotograph(true)}
      >
        <CollectionsOutlined color="primary" sx={{ mx: 1 }} />
        <Typography>写真</Typography>
      </Box>
      <Drawer
        anchor="right"
        open={openPhotograph}
        onClose={() => setOpenPhotograph(false)}
        sx={{
          "& .MuiDrawer-paper": {
            overflowY: "visible",
          },
        }}
      >
        <Box display="flex" flexDirection="column" width={800} p={5}>
          <Box
            position="absolute"
            left="-70px"
            top={15}
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => setOpenPhotograph(false)}
          >
            <CloseOutlined style={{ color: "white", fontSize: "50px" }} />
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="end">
            <Typography variant="h5" fontWeight="bold">
              写真
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {`${currentSlide}/${itemData.length}`}
            </Typography>
          </Box>

          <Box my={3}>
            <Slider
              ref={slideRef}
              dots={false}
              infinite={true}
              speed={500}
              slidesToShow={1}
              beforeChange={(current, next) => setCurrentSlide(next)}
              prevArrow={<PrevSliderArrow />}
              nextArrow={<NextSliderArrow />}
            >
              {itemData.map((item, index) => {
                return (
                  <Box
                    key={index}
                    height="390px"
                    width="790px"
                    component="img"
                    src={`/images/store-detail/img${item}.jpg`}
                  />
                );
              })}
            </Slider>
          </Box>

          <ImageList cols={8} rowHeight={90}>
            {itemData.map((item) => (
              <ImageListItem
                key={item.toString()}
                onClick={() => handleSelectImage(item)}
                sx={{
                  cursor: "pointer",
                  opacity: item - 1 === currentSlide ? 1 : 0.4,
                }}
              >
                <img
                  srcSet={`/images/store-detail/img${item}.jpg?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                  src={`/images/store-detail/img${item}.jpg?w=164&h=164&fit=crop&auto=format`}
                  alt={item.toString()}
                  loading="lazy"
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
      </Drawer>
    </>
  );
}
